import { useState } from "react";
import {
  getFilterAlreadyApplied,
  getFilterAlreadyAppliedCheckBoxGroup,
  getOtherDependentFilters,
} from "./appliedCheckBoxesUtils";

export interface AppliedCheckboxResult {
  appliedCheckboxes?: AppliedCheckbox[];
  setAppliedCheckboxes?: React.Dispatch<
    React.SetStateAction<AppliedCheckbox[]>
  >;
  setAppliedCheckboxesCheckBoxGroup?: (
    filterKey: string,
    categoryKeyWithoutDeclaration: string,
    groupedBy: string,
    parentFilterKey: string
  ) => AppliedCheckbox[];
  setAppliedCheckboxesCheckBoxGroupRemoveChip?: (
    appliedCheckboxes: AppliedCheckbox[],
    filterKey: string,
    categoryKey: string
  ) => void;
  setAppliedCheckboxesSingleSelect?: (
    filterKey: string,
    categoryKey: string
  ) => AppliedCheckbox[];
}

export interface AppliedCheckbox {
  filterKey: string;
  categoryKey: string;
  groupedBy: string;
  parentFilterKey: any;
}

export const DEFAULT_APPLIED_CHECKBOXES = [
  {
    filterKey: "Any",
    categoryKey: "Eligibility",
    groupedBy: null,
    parentFilterKey: null,
  },
  {
    filterKey: "Any",
    categoryKey: "Payment",
    groupedBy: null,
    parentFilterKey: null,
  },
];

const useAppliedCheckBoxes = (): AppliedCheckboxResult => {
  const [appliedCheckboxes, setAppliedCheckboxes] = useState<AppliedCheckbox[]>(
    DEFAULT_APPLIED_CHECKBOXES
  );

  const setAppliedCheckboxesCheckBoxGroup = (
    filterKey,
    categoryKey,
    groupedBy,
    parentFilterKey
  ) => {
    let newState = null;

    const filterAlreadyAppliedCheckBoxGroup =
      getFilterAlreadyAppliedCheckBoxGroup(
        appliedCheckboxes,
        categoryKey,
        filterKey,
        groupedBy
      );
    const otherDependentFilters = getOtherDependentFilters(
      appliedCheckboxes,
      categoryKey,
      filterKey
    );

    if (filterAlreadyAppliedCheckBoxGroup) {
      newState = [
        ...appliedCheckboxes.filter(
          (item) =>
            item !== filterAlreadyAppliedCheckBoxGroup &&
            !otherDependentFilters.find(
              (value) => value.filterKey === item.filterKey
            )
        ),
      ];
    } else {
      newState = [
        ...appliedCheckboxes,
        { filterKey, categoryKey, groupedBy, parentFilterKey },
      ];
    }

    setAppliedCheckboxes([...newState]);
    return [...newState];
  };

  const setAppliedCheckboxesSingleSelect = (filterKey, categoryKey) => {
    let newState = null;
    const isAlreadyApplied = appliedCheckboxes.some(
      (el) => el.categoryKey === categoryKey
    );
    if (isAlreadyApplied) {
      const singleSelectedIndex = appliedCheckboxes.findIndex(
        (el) => el.categoryKey === categoryKey
      );
      newState = [...appliedCheckboxes];
      newState[singleSelectedIndex].filterKey = filterKey;
      setAppliedCheckboxes([...newState]);
      return [...newState];
    } else {
      newState = [
        ...appliedCheckboxes,
        {
          filterKey,
          categoryKey,
          groupedBy: null,
          parentFilterKey: null,
        },
      ];
      setAppliedCheckboxes([...newState]);
      return [...newState];
    }
  };

  const setAppliedCheckboxesCheckBoxGroupRemoveChip = (
    appliedCheckboxes,
    filterKey,
    categoryKey
  ) => {
    let newState = null;

    const filterAlreadyApplied = getFilterAlreadyApplied(
      appliedCheckboxes,
      categoryKey,
      filterKey
    );
    const otherDependentFilters = getOtherDependentFilters(
      appliedCheckboxes,
      categoryKey,
      filterKey
    );

    if (!filterAlreadyApplied && !otherDependentFilters) {
      return;
    }

    newState = [
      ...appliedCheckboxes.filter(
        (item) =>
          item !== filterAlreadyApplied &&
          !otherDependentFilters.find(
            (value) => value.filterKey === item.filterKey
          )
      ),
    ];
    setAppliedCheckboxes([...newState]);
  };

  return {
    appliedCheckboxes,
    setAppliedCheckboxes,
    setAppliedCheckboxesCheckBoxGroup,
    setAppliedCheckboxesCheckBoxGroupRemoveChip,
    setAppliedCheckboxesSingleSelect,
  };
};

export default useAppliedCheckBoxes;
